module.exports = __webpack_public_path__ + "bca675021ce8fe09c41a2e0ba9d38a0d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/btnControlSpeaker.png
// module id = k0hK
// module chunks = 27